import { FORM_FIELD_TYPE } from '../constants/common';

import messages from './messages';

const COMMON_KEYS = {
  city: 'Farm City / Town',
  country: 'Farm Country',
  description: 'Farm Description',
  full_address: 'Farm Address',
  holding_numbers: 'Holding Number',
  house_number: 'House number / Name',
  identifier: 'Farm ID',
  name: 'Farm Name',
  postal_code: 'Farm Postal Code',
  size: 'Farm Size (ha)',
  street: 'Farm Street Name'
};

export const KEY_MAP = {
  ...COMMON_KEYS,
  actual_livestock: 'Actual Tracked Livestock',
  address: 'Farm Address',
  animals_count: 'Assigned Livestock',
  circumference: 'Farm Perimeter (km)',
  expected_livestock: 'Expected Tracked Livestock',
  geofence_id: 'Pasture ID'
};

export const NEW_FARM_KEY_MAP = {
  ...COMMON_KEYS,
  circumference: 'Circumference (km)',
  farm_rules: 'Farm Rules',
  geofence_id: 'Pasture ID',
  geofences: 'Pastures'
};

export const FARM_CREATE_FIELDS = [
  {
    id: 'name',
    type: FORM_FIELD_TYPE.INPUT,
    name: NEW_FARM_KEY_MAP['name'],
    rules: [
      {
        required: true,
        message: messages.DATA_REQUIRED
      }
    ]
  },
  // {
  //   id: 'country',
  //   type: FORM_FIELD_TYPE.SELECT,
  //   name: NEW_FARM_KEY_MAP['country']
  // },
  // {
  //   id: 'city',
  //   type: FORM_FIELD_TYPE.TAGS,
  //   name: NEW_FARM_KEY_MAP['city']
  // },
  {
    id: 'street',
    type: FORM_FIELD_TYPE.INPUT,
    name: NEW_FARM_KEY_MAP['street']
  },
  {
    id: 'house_number',
    type: FORM_FIELD_TYPE.INPUT,
    name: NEW_FARM_KEY_MAP['house_number']
  },
  {
    id: 'postal_code',
    type: FORM_FIELD_TYPE.INPUT,
    name: NEW_FARM_KEY_MAP['postal_code']
  },

  {
    id: 'holding_numbers',
    type: FORM_FIELD_TYPE.NUMBER,
    name: NEW_FARM_KEY_MAP['holding_numbers']
  },
  {
    id: 'description',
    editable: true,
    type: FORM_FIELD_TYPE.TEXTAREA,
    name: NEW_FARM_KEY_MAP['description']
  }
];

export const FARM_EDIT_FIELDS = [
  {
    id: 'identifier',
    editable: false,
    type: FORM_FIELD_TYPE.INPUT,
    name: KEY_MAP['identifier']
  },
  {
    id: 'name',
    editable: true,
    type: FORM_FIELD_TYPE.INPUT,
    rules: [
      {
        required: true,
        message: messages.DATA_REQUIRED
      }
    ],
    name: KEY_MAP['name']
  },
  // {
  //   id: 'country',
  //   editable: true,
  //   type: FORM_FIELD_TYPE.SELECT,
  //   name: KEY_MAP['country']
  // },
  // {
  //   id: 'city',
  //   editable: true,
  //   type: FORM_FIELD_TYPE.TAGS,
  //   name: KEY_MAP['city']
  // },
  {
    id: 'street',
    editable: true,
    type: FORM_FIELD_TYPE.INPUT,
    name: NEW_FARM_KEY_MAP['street']
  },
  {
    id: 'house_number',
    editable: true,
    type: FORM_FIELD_TYPE.INPUT,
    name: KEY_MAP['house_number']
  },
  {
    id: 'postal_code',
    editable: true,
    type: FORM_FIELD_TYPE.INPUT,
    name: KEY_MAP['postal_code']
  },
  {
    id: 'size',
    editable: false,
    type: FORM_FIELD_TYPE.NUMBER,
    name: KEY_MAP['size']
  },
  {
    id: 'circumference',
    editable: false,
    type: FORM_FIELD_TYPE.NUMBER,
    name: KEY_MAP['circumference']
  },
  {
    id: 'holding_numbers',
    editable: true,
    type: FORM_FIELD_TYPE.NUMBER,
    name: KEY_MAP['holding_numbers']
  },
  {
    id: 'animals_count',
    editable: false,
    type: FORM_FIELD_TYPE.NUMBER,
    name: KEY_MAP['animals_count']
  },
  {
    id: 'expected_livestock',
    editable: false,
    type: FORM_FIELD_TYPE.NUMBER,
    name: KEY_MAP['expected_livestock']
  },
  {
    id: 'actual_livestock',
    editable: false,
    type: FORM_FIELD_TYPE.NUMBER,
    name: KEY_MAP['actual_livestock']
  },
  {
    id: 'description',
    editable: true,
    type: FORM_FIELD_TYPE.TEXTAREA,
    name: KEY_MAP['description']
  }
];
